"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getChildStepsNodes;

function getChildStepsNodes(ref) {
  if (ref) {
    return ref.querySelectorAll('li[role="option"]');
  }

  return [];
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-rainbow-components/components/Path/helpers/getChildStepsNodes.js
// module id = yOvH
// module chunks = 0